import { render, staticRenderFns } from "./FreeGiftConditionIframe.vue?vue&type=template&id=e655315a&"
import script from "./FreeGiftConditionIframe.vue?vue&type=script&lang=ts&"
export * from "./FreeGiftConditionIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports